<template>
  <div
    class="flex items-center justify-center rounded-lg overflow-hidden flex-shrink-0"
    :class="[size, logoUrl && !errored ? 'bg-white ring-1 ring-black/5' : 'bg-blue-600']"
  >
    <img
      v-if="logoUrl && !errored"
      :src="logoUrl"
      :alt="name"
      class="w-full h-full object-contain"
      :class="imagePadding"
      @error="errored = true"
    />
    <span v-else class="font-semibold text-white" :class="initialTextSize">{{ initial }}</span>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const props = defineProps({
  name: { type: String, required: true },
  logoUrl: { type: String, default: null },
  size: { type: String, default: 'w-8 h-8' },
  initialTextSize: { type: String, default: 'text-xs' },
  // Smaller call sites (e.g. AttachDependencyForm's compact target field)
  // want the logo image itself to fill more of its box than the default
  // p-1 allows, since that padding eats a much bigger share of a 16px box.
  imagePadding: { type: String, default: 'p-1' },
})

const errored = ref(false)
watch(() => props.logoUrl, () => { errored.value = false })

const initial = computed(() => props.name?.trim()?.[0]?.toUpperCase() || '?')
</script>
